import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Link from 'next/link';
import Router from "next/router";
import { closeModal } from '../../redux/actions';
import { Cross, Logo } from '../../utils';
import { Loader } from "../../components";

import {
  ModalWrapper,
  ModalContainer,
  ModalOverlay,
  ModalClose,
  ModalHeading,
  ModalDescription,
  ModalFooter,
  LogoContainer,
  ModalLoader,
} from './styles';

const mapStateToProps = state => ({
  isFetching: state.user.isFetching,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleCloseButtonClick: closeModal,
}, dispatch);

@connect(
  mapStateToProps,
  mapDispatchToProps,
)
class SlideInModal extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    name: PropTypes.string,
    handleCloseButtonClick: PropTypes.func,
    isFetching: PropTypes.bool,
    isClosable: PropTypes.bool,
  };

  static defaultProps = {
    isClosable: true,
  };

  static Heading = ModalHeading;

  static Description = ModalDescription;

  static Footer = ModalFooter;

  constructor(props) {
    super(props);

    this.overlay = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('click', this.handleClick);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('click', this.handleClick);
  }

  handleKeyDown = evt => {
    const { handleCloseButtonClick, name } = this.props;
    if (evt.key === 'Escape') {
      handleCloseButtonClick(name);
      window.removeEventListener('keydown', this.handleKeyDown);
    }
  };

  handleClick = evt => {
    const { target } = evt;
    const { handleCloseButtonClick, name, isClosable } = this.props;

    if(!isClosable && target === this.overlay.current) {
      Router.push('/');
      return
    }
    if (target === this.overlay.current) {
      handleCloseButtonClick(name);
      window.removeEventListener('click', this.handleClick);
    }
  };

  render() {
    const { children, handleCloseButtonClick, name, isFetching } = this.props;

    return (
      <ModalWrapper>
        <ModalOverlay ref={this.overlay} />
        <ModalContainer>
          {isFetching && (
            <ModalLoader>
              <Loader size={150} />
            </ModalLoader>
          )}
          <Link href="/">
            <LogoContainer>
              <Logo width={140} height={32} />
            </LogoContainer>
          </Link>
          <ModalClose onClick={name ? () => handleCloseButtonClick(name) : () => Router.push('/')}>
            <Cross width={17} height={17} />
          </ModalClose>
          {children}
        </ModalContainer>
      </ModalWrapper>
    );
  }
}

export default SlideInModal;
